module.exports = __webpack_public_path__ + "img/corsi_smartform.42505ab7.png";